String.prototype.replaceAll = function (search, replacement) {
    let target = this;
    return target.split(search).join(replacement);
};
let canvas = null;
// Replace requires with imports
import $ from "jquery";
import _ from "lodash";
import moment from "moment";
import FontService from "./services/font-service";
let widthCache = {};
let fontReady = false;

const Utils = {
    emptyOrNull(string) {
        return !string || string.trim() === "";
    },
    round(num) {
        if (!num) {
            return num;
        }
        return Math.round(num * 100) / 100;
    },
    anyEmptyOrNull(list) {
        let empty = false;
        _.forEach(list, (item) => {
            if (this.emptyOrNull(item)) {
                empty = true;
                return false;
            }
        });
        return empty;
    },
    length(value, trim = true) {
        return value ? (trim ? value.trim().length : value.length) : 0;
    },

    arrayDelete(arr, object, replace = null) {
        if (replace) {
            arr.splice(arr.indexOf(object), 1, replace);
        } else {
            arr.splice(arr.indexOf(object), 1);
        }
    },
    getFileImageData(input) {
        return new Promise((resolve, reject) => {
            if (input.files && input.files[0]) {
                let ext = $(input).val().split(".").pop().toLowerCase();
                if ($.inArray(ext, ["gif", "png", "jpg", "jpeg"]) === -1) {
                    alert("Invalid file.");
                    $(input).val(null);
                    reject(new Error("Invalid file."));
                } else {
                    let reader = new FileReader();
                    reader.onload = function (e) {
                        resolve(e.target.result);
                    };
                    reader.readAsDataURL(input.files[0]);
                }
            } else {
                resolve(null);
            }
        });
    },

    /**
     * https://stackoverflow.com/questions/13070054/convert-rgb-strings-to-hex-in-javascript
     * @param {string} rgb
     * @returns {string}
     */
    rgbToHex(rgb) {
        let a = rgb.split("(")[1].split(")")[0];
        a = a.split(",");
        let b = a.map(function (x) {
            //For each array element
            x = parseInt(x).toString(16); //Convert to a base16 string
            return x.length === 1 ? "0" + x : x; //Add zero if we get only one character
        });
        return "#" + b.join("").toUpperCase();
    },

    /**
     *
     * @param {Moment} date
     * @param {string} weekdays
     * @returns Array
     */
    getWeekdaysInMonth(date, weekdays) {
        let days = function (start, end, weekdays, index = null) {
            let days = [],
                d = moment(start).startOf("day");
            let isIndexed = typeof index !== "undefined" && index !== null;

            if (typeof weekdays !== "undefined" && weekdays !== null) {
                if (weekdays.constructor !== Array) {
                    weekdays = [weekdays];
                }

                for (let w = 0; w < weekdays.length; w++) {
                    weekdays[w] = moment(start).day(weekdays[w]).day();
                }
            } else {
                weekdays = [0, 1, 2, 3, 4, 5, 6];
            }

            for (
                let i = 0;
                i < moment(end).endOf("day").diff(moment(start), "days") + 1;
                i++
            ) {
                let wd = d.day();

                if (isIndexed && !days[wd]) {
                    days[wd] = [];
                }

                if (weekdays.indexOf(wd) !== -1) {
                    if (isIndexed) {
                        days[wd].push(moment(d));
                    } else {
                        days.push(moment(d));
                    }
                }

                d.add(1, "day");
            }

            if (isIndexed) {
                let nDays = [];

                if (index.constructor !== Array) {
                    index = [index];
                }

                for (let a = 0; a < days.length; a++) {
                    if (!days[a].length) {
                        continue;
                    }

                    for (let n = 0; n < index.length; n++) {
                        let ind = parseInt(index[n]);
                        if (isNaN(ind)) {
                            continue;
                        }
                        let ni = ind - 1;
                        if (ind < 0) {
                            ni = days[a].length + ind;
                        }
                        nDays.push(days[a][ni]);
                    }
                }

                days = nDays;
            }

            days = days
                .sort(function (a, b) {
                    return moment.utc(a).diff(moment.utc(b));
                })
                .filter(function (o, p, a) {
                    return o != null && !moment(o).isSame(a[p - 1]);
                });

            if (!days.length) {
                return false;
            }
            if (days.length === 1) {
                return days[0];
            }

            return days;
        };
        return days(
            moment(date).date(1),
            moment(date).endOf("month"),
            weekdays
        );
    },
    /**
     *
     * @param {String} str
     * @param {Number} width
     * @param {String} spaceReplacer
     * @returns {*}
     */
    wordwrap(str, width, spaceReplacer) {
        if (str.length > width) {
            let p = width;
            for (; p > 0 && str[p] !== " "; p--) {}
            if (p > 0) {
                let left = str.substring(0, p);
                let right = str.substring(p + 1);
                return (
                    left +
                    spaceReplacer +
                    this.wordwrap(right, width, spaceReplacer)
                );
            }
        }
        return str;
    },
    /**
     * @param {String} text
     * @return {String}
     */
    convertTextToHtml(text) {
        return this.htmlentities(text).replaceAll("\n", "<br/>");
    },
    /**
     * @param {String} str
     * @returns {String}
     */
    htmlentities(str) {
        return $("<div/>").text(str).html();
    },
    /**
     * @param {String} html
     * @param {Array.<String>} except
     * @returns {string}
     */
    removeTags(html, except = []) {
        /**
         * @type {{tag: String, replaceWith: String}[]}
         */
        let except_temp = except.map((tag) => {
            return {
                tag,
                replaceWith: tag
                    .replaceAll("<", "||")
                    .replaceAll(">", "||")
                    .replaceAll("/>", "||")
            };
        });
        except_temp.forEach((tag) => {
            html = html.replaceAll(tag.tag, tag.replaceWith);
        });
        let tmp = document.createElement("div");
        tmp.innerHTML = html;
        html = tmp.textContent || tmp.innerText;
        except_temp.forEach((tag) => {
            html = html.replaceAll(tag.replaceWith, tag.tag);
        });
        return html;
    },
    /**
     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
     */
    getTextWidthCanvas(text, font, font_size, fontWeight = null) {
        if (!canvas) {
            canvas = document.createElement("canvas");
        }
        let context = canvas.getContext("2d");
        context.font = `${
            fontWeight ? fontWeight + " " : ""
        }${font_size}pt ${font}`;
        let metrics = context.measureText(text);
        return metrics.width;
    },

    /**
     * Splits text into wrapped lines based on font properties and maximum width.
     *
     * This function handles:
     * - Text wrapping at word boundaries
     * - Multiple lines from newline characters
     * - Hyphenated word splitting for better layout
     * - Balanced line distribution for multi-line text
     *
     * @param {string} text - The text to be wrapped
     * @param {string} font - The font name
     * @param {number} font_size - The font size in points
     * @param {string|number} font_weight - The font weight
     * @param {number} maxWidth - The maximum width for each line in pixels
     * @returns {string[]} An array of wrapped lines
     */
    getWrappedLines(text, font, font_size, font_weight, maxWidth) {
        // Debug mode can be enabled for specific texts
        const debug = false;

        // --- VALIDATION ---
        if (!text || text.trim().length === 0 || !maxWidth || maxWidth <= 0) {
            return text ? [text] : [];
        }

        if (debug) {
            console.group("getWrappedLines");
            console.log("Input:", {
                text,
                font,
                font_size,
                font_weight,
                maxWidth
            });
        }

        // --- HELPER FUNCTIONS ---

        /**
         * Get the pixel width of text with the current font settings
         * @param {string} textToMeasure - Text to measure
         * @returns {number} Width in pixels
         */
        const getWidth = (textToMeasure) => {
            const width = this.getTextWidth(
                textToMeasure,
                font,
                font_size,
                font_weight
            );
            if (debug) console.log(`Width of "${textToMeasure}" = ${width}px`);
            return width;
        };

        /**
         * Splits a long word that exceeds maximum width into multiple pieces
         * @param {string} word - Word to split
         * @param {number} [width=maxWidth] - Maximum width for the word pieces
         * @returns {string[]} Array of word pieces
         */
        const splitWord = (word, width = maxWidth) => {
            const adjustedWidth = width; // No safety margin needed
            let split_words = [];
            let current_line = "";

            if (debug) {
                console.log(
                    `Splitting word: "${word}" to fit within ${adjustedWidth}px`
                );
            }

            // Split the word character by character
            for (let i = 0; i < word.length; i++) {
                const char = word[i];
                // Check if adding this character would exceed the width
                if (getWidth(current_line + char) > adjustedWidth) {
                    if (current_line === "") {
                        // If we can't even fit one character, force add it
                        current_line = char;
                        split_words.push(current_line);
                        current_line = "";
                    } else {
                        // Otherwise add the current line and reset
                        split_words.push(current_line);
                        current_line = char;
                    }
                } else {
                    current_line += char;
                    // Add the final piece if we're at the end
                    if (i === word.length - 1) {
                        split_words.push(current_line);
                    }
                }
            }

            if (debug) {
                console.log("Split result:", split_words);
            }

            return split_words;
        };

        /**
         * Processes text with newlines
         * @param {string} textWithNewlines - Text potentially containing newlines
         * @returns {string[]} Array of wrapped lines
         */
        const processMultiLineText = (textWithNewlines) => {
            const split_lines = textWithNewlines.split("\n");
            if (split_lines.length <= 1) return null;

            const lines = [];
            split_lines.forEach((line) => {
                this.getWrappedLines(
                    line,
                    font,
                    font_size,
                    font_weight,
                    maxWidth
                ).forEach((item) => lines.push(item));
            });
            return lines;
        };

        /**
         * Processes hyphenated words for better wrapping
         * @param {string[]} words - Array of words
         * @returns {string[]} Processed array with hyphenated words split
         */
        const processHyphenatedWords = (words) => {
            const result = [];

            words.forEach((word) => {
                // Only process internal hyphens (not at the end of the word)
                if (
                    word.includes("-") &&
                    !word.endsWith("-") &&
                    word.length > 5
                ) {
                    const hyphenIndex = word.indexOf("-");
                    // Only split if the hyphen isn't at the end
                    if (hyphenIndex > 0 && hyphenIndex < word.length - 1) {
                        const parts = [];
                        const hyphenParts = word.split("-");

                        for (let i = 0; i < hyphenParts.length; i++) {
                            if (i < hyphenParts.length - 1) {
                                // Keep the hyphen with the first part
                                parts.push(hyphenParts[i] + "-");
                            } else {
                                parts.push(hyphenParts[i]);
                            }
                        }
                        result.push(...parts);
                    } else {
                        result.push(word);
                    }
                } else {
                    result.push(word);
                }
            });

            return result;
        };

        /**
         * Processes words with special characters (hyphens and colons) for better wrapping
         * @param {string[]} words - Array of words
         * @returns {string[]} Processed array with special character words split
         */
        const processSpecialCharacterWords = (words) => {
            const result = [];
            const specialChars = ["-", ":"];

            words.forEach((word) => {
                // Check if word contains any special character
                const hasSpecialChar = specialChars.some((char) =>
                    word.includes(char)
                );

                if (hasSpecialChar && word.length > 5) {
                    // Find which special character to process first (the leftmost one)
                    let charToProcess = null;
                    let charIndex = word.length;

                    specialChars.forEach((char) => {
                        const index = word.indexOf(char);
                        if (index > 0 && index < charIndex) {
                            charToProcess = char;
                            charIndex = index;
                        }
                    });

                    // Only process if we found a valid special character in the middle
                    if (
                        charToProcess &&
                        !word.endsWith(charToProcess) &&
                        charIndex < word.length - 1
                    ) {
                        // Split word at the special character for line breaking purposes only
                        const firstPart = word.substring(0, charIndex + 1); // Include the special character
                        const secondPart = word.substring(charIndex + 1); // Rest of the word

                        // Add the parts as separate "words" for line breaking
                        result.push(firstPart);
                        result.push(secondPart);
                    } else {
                        result.push(word);
                    }
                } else {
                    result.push(word);
                }
            });

            return result;
        };

        // --- MAIN PROCESSING ---

        // 1. Handle text with newlines first
        text = text
            .trim()
            .replace(
                new RegExp(
                    window.App.state.config.settings.calendar.newline_char,
                    "g"
                ),
                "\n"
            );

        const multiLineResult = processMultiLineText(text);
        if (multiLineResult) {
            if (debug) console.groupEnd();
            return multiLineResult;
        }

        // 2. Split text into words and process hyphenated words
        const spaceWords = text.split(" ");
        const words = processSpecialCharacterWords(
            processHyphenatedWords(spaceWords)
        );

        // 3. Early checks for empty or single word text
        if (words.length === 0) {
            if (debug) console.groupEnd();
            return [];
        }

        if (words.length === 1) {
            const singleWord = words[0];
            if (getWidth(singleWord) <= maxWidth) {
                if (debug) console.groupEnd();
                return [singleWord];
            }
            // Split the single word if it's too wide
            if (debug) console.groupEnd();
            return splitWord(singleWord);
        }

        // 4. Use balanced line distribution for multi-line text
        const totalWidth = getWidth(text);
        const estimatedLines = Math.ceil(totalWidth / maxWidth);

        if (debug) {
            console.log(
                `Estimated lines based on width (${totalWidth}px): ${estimatedLines}`
            );
        }

        if (estimatedLines > 1) {
            // Use the balanced line algorithm for better distribution
            if (debug) console.groupEnd();
            return this.getBalancedLines(
                words,
                getWidth,
                maxWidth,
                estimatedLines
            );
        }

        // 5. Fallback: Process each word with simple wrapping algorithm
        let current_line = "";
        let lines = [];
        let count = 0; // Safety counter to prevent infinite loops

        while (words.length && count < 5000) {
            count++;
            const word = words[0];
            const current_line_temp =
                current_line + (current_line ? " " : "") + word;

            if (debug) {
                console.log(
                    `Processing: "${word}", Current: "${current_line}", New: "${current_line_temp}"`
                );
            }

            // Helper to remove the first word from the array
            const removeFirstWord = () => {
                words.shift();
                if (debug) console.log(`Words remaining:`, words.length);
            };

            // Handle words that are too wide by themselves
            if (getWidth(word) > maxWidth) {
                if (debug) console.log(`Word "${word}" is too wide, splitting`);
                removeFirstWord();
                splitWord(word).forEach((part) => words.push(part));
                continue;
            }

            // Check if adding the word would exceed maxWidth
            if (getWidth(current_line_temp) > maxWidth) {
                if (current_line !== "") {
                    // If there's already content on the line, try to split long words
                    const wordWidth = getWidth(word);
                    const remainingWidth =
                        maxWidth - getWidth(current_line + " ");

                    // Only try to split significant words (>30% of max width)
                    if (wordWidth > maxWidth * 0.3 && remainingWidth > 15) {
                        if (debug)
                            console.log(
                                `Trying to split "${word}" to fit remaining ${remainingWidth}px`
                            );

                        const split_words = splitWord(word, remainingWidth);

                        if (split_words.length > 1) {
                            // Add first part to current line and remaining parts as new words
                            current_line += " " + split_words[0];
                            lines.push(current_line);
                            current_line = "";

                            for (let i = 1; i < split_words.length; i++) {
                                words.push(split_words[i]);
                            }
                            removeFirstWord();
                            continue;
                        }
                    }
                }

                // Standard line breaking
                lines.push(current_line);
                current_line = "";
            } else {
                // Word fits on line, add it normally
                current_line += (current_line ? " " : "") + word;
                removeFirstWord();

                if (!words.length) {
                    lines.push(current_line);
                }
            }
        }

        if (count >= 5000) {
            console.warn(
                "Forced break from potential infinite loop in text wrapping"
            );
        }

        // Filter empty lines and handle edge case
        lines = lines.filter((line) => line && line.trim().length > 0);

        if (lines.length === 0 && text && text.trim().length > 0) {
            lines = [text.trim()];
        }

        if (debug) {
            console.log("Final wrapped lines:", lines);
            console.groupEnd();
        }

        return lines;
    },
    //check for support of OffScreenCanvas
    isOffscreenCanvasSupported() {
        return typeof OffscreenCanvas !== "undefined";
    },
    //get text width using OffScreenCanvas
    getTextWidthOffscreenCanvas(text, font, font_size, fontWeight = null) {
        if (!this.isOffscreenCanvasSupported()) {
            return this.getTextWidthCanvas(text, font, font_size, fontWeight);
        }

        let canvas = new OffscreenCanvas(0, 0);
        let context = canvas.getContext("2d");

        context.font = `${
            fontWeight ? fontWeight + " " : ""
        }${font_size}pt ${font}`;
        let metrics = context.measureText(text);
        return metrics.width;
    },
    getTextWidth(text, font, font_size, fontWeight = null) {
        // Return 0 for empty text
        if (!text || text.length === 0) return 0;

        // Try cached value first (update the cache key to include proper weight)
        const cacheKey = `${text}_${font}_${font_size}_${fontWeight}`;
        if (widthCache[cacheKey]) {
            return widthCache[cacheKey];
        }

        // Get the actual weight value if using a font with embedded weight
        if (!fontWeight) {
            fontWeight = FontService.getFontWeightFromCSS(font);
        }

        // Use the best available method
        let width = 0;

        // Primary method - canvas
        try {
            if (this.isOffscreenCanvasSupported()) {
                width = this.getTextWidthOffscreenCanvas(
                    text,
                    font,
                    font_size,
                    fontWeight
                );
            } else {
                width = this.getTextWidthCanvas(
                    text,
                    font,
                    font_size,
                    fontWeight
                );
            }
        } catch (e) {
            console.warn("Canvas text measurement failed:", e);
        }

        // Fallback method - character estimation if canvas measurement failed or returned suspicious values
        if (!width || width <= 0 || isNaN(width)) {
            width = this.getTextWidthEstimated(text, font_size);
        }

        // Cache and return
        widthCache[cacheKey] = width;
        return width;
    },
    /**
     * Fallback method to estimate text width based on character count
     */
    getTextWidthEstimated(text, font_size) {
        // Average width of characters in points (adjust based on your needs)
        const avgCharWidth = font_size * 0.5;
        return text.length * avgCharWidth;
    },
    /**
     * Ensures fonts are ready before measuring text
     * @returns {Promise<boolean>}
     */
    ensureFontsLoaded() {
        if (!this._fontLoadingPromise) {
            this._fontLoadingPromise = new Promise((resolve) => {
                if (document && document.fonts && document.fonts.ready) {
                    document.fonts.ready.then(
                        () => {
                            console.log("Fonts loaded successfully");
                            this.fontReady = true;
                            resolve(true);
                        },
                        (error) => {
                            console.warn(
                                "Font loading error, using fallback",
                                error
                            );
                            this.fontReady = true; // Continue anyway after error
                            resolve(false);
                        }
                    );
                } else {
                    // No font loading API available, assume fonts are ready
                    this.fontReady = true;
                    resolve(true);
                }
            });
        }
        return this._fontLoadingPromise;
    },
    isFontReady() {
        if (document && document.fonts) {
            if (!this.fontReady) {
                document.fonts.ready.then(
                    (result) => {
                        //console.log("fonts ready", result);
                        this.fontReady = true;
                    },
                    (error) => console.log("fonts ready error", error)
                );
            }
        } else {
            this.fontReady = true;
        }
        return this.fontReady;
    },
    getBalancedLines(words, getWidthFn, maxWidth, estimatedLines) {
        // Keep existing debug logging
        const debug = false;

        if (debug) {
            console.group("🔍 getBalancedLines Debug");
            console.log("Input:", {
                words: words.join(" "),
                maxWidth,
                estimatedLines,
                wordCount: words.length
            });
        }

        // Simple validation (keep existing code)
        if (!words || words.length === 0) {
            if (debug) {
                console.log("⚠️ No words provided, returning empty array");
                console.groupEnd();
            }
            return [];
        }
        if (words.length === 1) {
            if (debug) {
                console.log("ℹ️ Only one word, returning as is:", words[0]);
                console.groupEnd();
            }
            return [words[0]];
        }

        // Calculate total width for reference
        const totalWidth = getWidthFn(words.join(" "));

        if (debug) {
            console.log("Total text width:", totalWidth, "pixels");
            console.log(
                "Target width per line:",
                totalWidth / estimatedLines,
                "pixels"
            );
        }

        // If everything fits on one line and we only need one line
        if (totalWidth <= maxWidth && estimatedLines === 1) {
            if (debug) {
                console.log("ℹ️ Text fits on one line, no balancing needed");
                console.groupEnd();
            }
            return [words.join(" ")];
        }

        // PASS 1: Simple word wrapping - keep existing implementation
        const lines = [];
        let currentLine = [];
        let currentLineWidth = 0;

        // Helper function to calculate width with spaces
        const getLineWidth = (line) =>
            line.length > 0 ? getWidthFn(line.join(" ")) : 0;

        if (debug) console.log("🔄 Starting PASS 1: Basic word wrapping");

        // First pass - standard word wrap algorithm (keep existing)
        for (let i = 0; i < words.length; i++) {
            const word = words[i];
            const wordWidth = getWidthFn(word);
            const spaceWidth = currentLine.length > 0 ? getWidthFn(" ") : 0;

            if (debug) {
                console.log(
                    `Word ${i + 1}/${words.length}: "${word}" (${wordWidth}px)`
                );
            }

            // Check if adding this word would exceed max width
            if (currentLineWidth + spaceWidth + wordWidth > maxWidth) {
                // If the current line has words, finish it and start a new one
                if (currentLine.length > 0) {
                    if (debug) {
                        console.log(
                            `  ↩️ Line break: "${currentLine.join(
                                " "
                            )}" (${currentLineWidth}px)`
                        );
                    }
                    lines.push(currentLine.join(" "));
                    currentLine = [word];
                    currentLineWidth = wordWidth;
                } else {
                    // If word is too wide for its own line, add it anyway
                    if (debug) {
                        console.log(
                            `  ⚠️ Word too wide for its own line: "${word}" (${wordWidth}px)`
                        );
                    }
                    lines.push(word);
                    currentLine = [];
                    currentLineWidth = 0;
                }
            } else {
                // Add word to current line
                currentLine.push(word);
                currentLineWidth = getLineWidth(currentLine);
                if (debug) {
                    console.log(
                        `  ➕ Added to line: "${currentLine.join(
                            " "
                        )}" (${currentLineWidth}px)`
                    );
                }
            }
        }

        // Add the last line if it has content
        if (currentLine.length > 0) {
            lines.push(currentLine.join(" "));
            if (debug) {
                console.log(
                    `  ↩️ Final line: "${currentLine.join(
                        " "
                    )}" (${currentLineWidth}px)`
                );
            }
        }

        if (debug) {
            console.log("📊 PASS 1 Results:");
            lines.forEach((line, i) => {
                const lineWidth = getWidthFn(line);
                const fillRatio = ((lineWidth / maxWidth) * 100).toFixed(1);
                console.log(
                    `  Line ${
                        i + 1
                    }: "${line}" (${lineWidth}px, ${fillRatio}% of max)`
                );
            });
        }

        // PASS 2: Rebalance lines - MODIFIED to balance ALL lines, not just the last one
        if (lines.length >= 2) {
            if (debug)
                console.log(
                    "🔄 Starting PASS 2: Line rebalancing for all lines"
                );

            // Convert lines back to arrays of words for easier manipulation
            const lineWords = lines.map((line) => line.split(" "));

            // Calculate how balanced the lines are
            const getLineWidths = () =>
                lineWords.map((line) => getWidthFn(line.join(" ")));
            let lineWidths = getLineWidths();

            if (debug) {
                console.log("Line widths before rebalancing:", lineWidths);
            }

            // Calculate ideal average line width for perfect balance
            const idealAvgLineWidth = totalWidth / lineWords.length;

            if (debug) {
                console.log(`Ideal average line width: ${idealAvgLineWidth}px`);
            }

            // Calculate line balance metric (standard deviation of line widths)
            const getBalanceMetric = (widths) => {
                const avg =
                    widths.reduce((sum, width) => sum + width, 0) /
                    widths.length;
                const variance =
                    widths.reduce(
                        (sum, width) => sum + Math.pow(width - avg, 2),
                        0
                    ) / widths.length;
                return Math.sqrt(variance); // Standard deviation
            };

            let balanceMetric = getBalanceMetric(lineWidths);

            if (debug) {
                console.log(
                    `Initial balance metric (lower is better): ${balanceMetric.toFixed(
                        2
                    )}px`
                );
            }

            // Continue rebalancing until we can't improve further
            let improved = true;
            let iterationCount = 0;
            const maxIterations = 15;
            const minImprovement = 1.0; // Minimum improvement in balance metric to continue

            while (improved && iterationCount < maxIterations) {
                iterationCount++;
                improved = false;

                if (debug) {
                    console.log(`Rebalance iteration ${iterationCount}:`);
                }

                // Try to move words from each line to the next line
                for (let i = 0; i < lineWords.length - 1; i++) {
                    if (lineWords[i].length <= 1) continue; // Keep at least one word per line

                    // Get the last word from the current line
                    const lastWord = lineWords[i][lineWords[i].length - 1];

                    // Calculate new line configurations if we move this word
                    const sourceLineWithoutWord = [
                        ...lineWords[i].slice(0, -1)
                    ];
                    const targetLineWithWord = [lastWord, ...lineWords[i + 1]];

                    const newSourceWidth = getWidthFn(
                        sourceLineWithoutWord.join(" ")
                    );
                    const newTargetWidth = getWidthFn(
                        targetLineWithWord.join(" ")
                    );

                    // Only move if target line wouldn't exceed max width
                    if (newTargetWidth <= maxWidth) {
                        // Calculate what the new balance would look like
                        const newWidths = [...lineWidths];
                        newWidths[i] = newSourceWidth;
                        newWidths[i + 1] = newTargetWidth;

                        const newBalanceMetric = getBalanceMetric(newWidths);

                        // Move the word if it improves balance
                        if (newBalanceMetric < balanceMetric - minImprovement) {
                            if (debug) {
                                console.log(
                                    `  Moving "${lastWord}" from line ${
                                        i + 1
                                    } to line ${i + 2}`
                                );
                                console.log(
                                    `  Balance metric improves from ${balanceMetric.toFixed(
                                        2
                                    )} to ${newBalanceMetric.toFixed(2)}`
                                );
                            }

                            // Move the word
                            lineWords[i].pop();
                            lineWords[i + 1].unshift(lastWord);

                            // Update metrics
                            lineWidths = getLineWidths();
                            balanceMetric = newBalanceMetric;
                            improved = true;

                            // If this emptied the line (shouldn't happen due to our check), remove it
                            if (lineWords[i].length === 0) {
                                lineWords.splice(i, 1);
                                i--; // Adjust index
                            }
                        }
                    }
                }

                // Also try moving words from later lines to earlier lines (for 3+ line scenarios)
                if (lineWords.length > 2) {
                    for (let i = lineWords.length - 1; i > 0; i--) {
                        if (lineWords[i].length <= 1) continue; // Keep at least one word per line

                        // Get the first word from the current line
                        const firstWord = lineWords[i][0];

                        // Calculate new line configurations if we move this word
                        const sourceLineWithoutWord = [
                            ...lineWords[i].slice(1)
                        ];
                        const targetLineWithWord = [
                            ...lineWords[i - 1],
                            firstWord
                        ];

                        const newSourceWidth = sourceLineWithoutWord.length
                            ? getWidthFn(sourceLineWithoutWord.join(" "))
                            : 0;
                        const newTargetWidth = getWidthFn(
                            targetLineWithWord.join(" ")
                        );

                        // Only move if target line wouldn't exceed max width
                        if (newTargetWidth <= maxWidth) {
                            // Calculate what the new balance would look like
                            const newWidths = [...lineWidths];
                            newWidths[i] = newSourceWidth;
                            newWidths[i - 1] = newTargetWidth;

                            const newBalanceMetric =
                                getBalanceMetric(newWidths);

                            // Move the word if it improves balance
                            if (
                                newBalanceMetric <
                                balanceMetric - minImprovement
                            ) {
                                if (debug) {
                                    console.log(
                                        `  Moving "${firstWord}" from line ${
                                            i + 1
                                        } to end of line ${i}`
                                    );
                                    console.log(
                                        `  Balance metric improves from ${balanceMetric.toFixed(
                                            2
                                        )} to ${newBalanceMetric.toFixed(2)}`
                                    );
                                }

                                // Move the word
                                lineWords[i].shift();
                                lineWords[i - 1].push(firstWord);

                                // Update metrics
                                lineWidths = getLineWidths();
                                balanceMetric = newBalanceMetric;
                                improved = true;

                                // If this emptied the line, remove it
                                if (lineWords[i].length === 0) {
                                    lineWords.splice(i, 1);
                                }
                            }
                        }
                    }
                }

                if (debug && improved) {
                    console.log(`After iteration ${iterationCount}:`);
                    lineWords.forEach((words, i) => {
                        const text = words.join(" ");
                        const width = getWidthFn(text);
                        const ratio = ((width / maxWidth) * 100).toFixed(1);
                        console.log(
                            `  Line ${i + 1}: "${text}" (${width}px, ${ratio}%)`
                        );
                    });
                    console.log(
                        `  Balance metric now: ${balanceMetric.toFixed(2)}`
                    );
                }
            }

            // Convert balanced lines back to strings
            const result = lineWords.map((line) => line.join(" "));

            if (debug) {
                console.log("📊 Final balanced lines:");
                result.forEach((line, i) => {
                    const lineWidth = getWidthFn(line);
                    const fillRatio = ((lineWidth / maxWidth) * 100).toFixed(1);
                    console.log(
                        `  Line ${
                            i + 1
                        }: "${line}" (${lineWidth}px, ${fillRatio}% of max)`
                    );
                });
                console.groupEnd();
            }

            return result;
        }

        if (debug) console.groupEnd();
        return lines;
    },
    clearWidthCache() {
        this.widthCache = {};
        return true;
    }
};

export default Utils;
